import { render, staticRenderFns } from "./ConventionMenu.vue?vue&type=template&id=76dd506f&scoped=true"
import script from "./ConventionMenu.vue?vue&type=script&lang=js"
export * from "./ConventionMenu.vue?vue&type=script&lang=js"
import style0 from "./ConventionMenu.vue?vue&type=style&index=0&id=76dd506f&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dd506f",
  null
  
)

export default component.exports